import { ViewerEventEnums } from './ViewerEvent'

export interface SnapshotDataDTO {
  id: number
  eventCount: number
  revenue: number
  year: number
  month: number
  eventType: ViewerEventEnums
  projectId: number
  projectName: string
  brandId: number
  brandName: string
  productId: number
  productName: string
  vovId: number
  vovName: string
  userId: string
}

export class SnapshotDataEntity {
  id: number
  eventCount: number
  revenue: number
  year: number
  month: number
  eventType: ViewerEventEnums
  projectId: number
  projectName: string
  brandId: number
  brandName: string
  productId: number
  productName: string
  vovId: number
  vovName: string
  userId: string

  constructor (entity: SnapshotDataDTO) {
    for (const property in entity) {
      this[property] = entity[property]
    }
  }

  get userEmail () {
    return this.userId
  }
}
